import { AfterViewInit, Component, Input, OnChanges, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { BaseModalComponent } from '../base-modal.component';

@Component({
  selector: 'app-tooltip-modal',
  standalone: true,
  imports: [],
  templateUrl: './tooltip-modal.component.html',
  styleUrl: './tooltip-modal.component.scss'
})
export class TooltipModalComponent extends BaseModalComponent implements AfterViewInit, OnChanges {
  @Input() text: string = '';
  @Input() isOpen: boolean = false;
  @ViewChild('content') content!: TemplateRef<any>;

  ngAfterViewInit(): void {
    if (this.isOpen) {
      this.open(this.content);
    }
  }

  override ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && this.isOpen) {
      this.open(this.content);
    }
  }
}
